import { V1PublicPatientGetAppointment200ResponseClinic } from '@packages/cortex-sdk/cortex-sdk/generated-client';
import { Clinic } from '@packages/types';

const GOOGLE_MAPS_BASE_URL = 'https://maps.google.com/';

export const clinicToGoogleMapsLink = (clinic?: Clinic) => {
  if (!clinic) return GOOGLE_MAPS_BASE_URL;
  const address =
    clinic?.address &&
    clinic?.address.street &&
    clinic?.address.zip &&
    clinic?.address.city
      ? encodeURIComponent(
          `${clinic?.address.street}, ${clinic?.address.zip} ${clinic?.address.city}`,
        )
      : '';
  const clinicName = encodeURIComponent(
    clinic?.name?.includes('Dr.Dropin')
      ? clinic.name
      : `Dr.Dropin ${clinic?.name}`,
  );
  return `${GOOGLE_MAPS_BASE_URL}?q=${clinicName}+${address}`;
};

// used for appointment status page (for now)
export const getGoogleMapsLink = (
  clinic: V1PublicPatientGetAppointment200ResponseClinic,
) => {
  const clinicName = encodeURIComponent(
    clinic?.name?.includes('Dr.Dropin')
      ? clinic.name
      : `Dr.Dropin ${clinic?.name}`,
  );

  const address = encodeURIComponent(
    `${clinic.address.street}, ${clinic.address.postalCode}, ${clinic.address.city}`,
  );
  return `${GOOGLE_MAPS_BASE_URL}?q=${clinicName}+${address}`;
};
